import React, { useRef } from 'react'
import {
  MessagesContainer,
  MessagesFlexContainer,
  MessagesWrapper,
  MobileChatOverlay,
} from './style'
import PropTypes from 'prop-types'
import { PinnedMessage } from './messages/PinnedMessage'
import { VirtualizedMessageList } from './VirtualizedMessageList'

const Messages = ({
  isDesktop = false,
  chatOpen,
  user,
  children,
  messages,
  hasMoreMessages,
  fetchMoreMessages,
  toggleChatMobile,
  isFetchingMoreMessages,
  getModeratorColorByUsername,
  pinnedMessage,
}) => {
  const isGestureLockedRef = useRef(false)
  const startYRef = useRef(0)
  const pinnedMessageRef = useRef(null)

  const unlockGesture = () => {
    setTimeout(() => {
      isGestureLockedRef.current = false
    }, 300)
  }

  const handleTouchStart = (e) => {
    startYRef.current = e.touches[0].clientY
  }

  const handleTouchMove = (e) => {
    if (isGestureLockedRef.current) return
    const currentY = e.touches[0].clientY
    const deltaY = currentY - startYRef.current

    if (deltaY > 50 && chatOpen) {
      toggleChatMobile(false)
      isGestureLockedRef.current = true
      unlockGesture()
    } else if (deltaY < -50 && !chatOpen) {
      toggleChatMobile(true)
      isGestureLockedRef.current = true
      unlockGesture()
    }
  }

  return (
    <>
      <MessagesWrapper>
        {!isDesktop && (
          <MobileChatOverlay
            onClick={() => toggleChatMobile(!chatOpen)}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
          >
            {children}
          </MobileChatOverlay>
        )}
        <MessagesFlexContainer isDesktop={isDesktop}>
          <MessagesContainer isDesktop={isDesktop} data-test="messages-container">
            {(messages.length === 0 && !isDesktop) || !chatOpen ? null : (
              <>
                <VirtualizedMessageList
                  messages={messages}
                  getModeratorColorByUsername={getModeratorColorByUsername}
                  hasMoreMessages={hasMoreMessages}
                  fetchMoreMessages={fetchMoreMessages}
                  isFetchingMoreMessages={isFetchingMoreMessages}
                  user={user}
                  isDesktop={isDesktop}
                  pinnedMessageRef={pinnedMessageRef}
                />
                {pinnedMessage && (
                  <PinnedMessage
                    ref={pinnedMessageRef}
                    getModeratorColorByUsername={getModeratorColorByUsername}
                    message={pinnedMessage}
                    isDesktop={isDesktop}
                  />
                )}
              </>
            )}
          </MessagesContainer>
        </MessagesFlexContainer>
      </MessagesWrapper>
    </>
  )
}

Messages.propTypes = {
  isDesktop: PropTypes.bool,
  chatOpen: PropTypes.bool,
  isFetchingMoreMessages: PropTypes.bool,
  user: PropTypes.object.isRequired,
  children: PropTypes.element,
  hasMoreMessages: PropTypes.bool,
  fetchMoreMessages: PropTypes.func,
  toggleChatMobile: PropTypes.func,
  messages: PropTypes.array,
  pinnedMessage: PropTypes.object,
  getModeratorColorByUsername: PropTypes.func,
}

export { Messages }
